
class ProductClassificationCell extends UITableViewCell
{
    private titleTextField:MUITextField = null;

    private _item:ProductClassification = null;

    awakeFromHTML(){
        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        if (this.titleTextField) this.titleTextField.setOnChangeText(this, function(this:ProductClassificationCell, control:MUITextField, value:string){
            if (this._item != null) this._item.title = value;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item:ProductClassification){
        this._item = item;
        this.titleTextField.text = item.title;
    }
}
